<template>
  <section
    class="monthly-cross-wrap"
    style=" width:100%;padding:20px 0">
    <v-layout
      align-center
      row
      wrap>
      <v-select
        :items="viewItems"
        v-model="selectedVal"
        attach
        item-text="label"
        item-value="value"
        label="Monthly Cross Charge View"
        @change="changeRoute"
      />
    </v-layout>
  </section>
</template>
<script>

import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'

export default {
  props: ['view'],
  data: () => ({
    selectedVal: null,
    viewItems: [
      {
        label: 'By AWS Agreement',
        value: 'aws-agreement'
      },
      {
        label: 'By Master Payer',
        value: 'master-payer'
      },
      {
        label: 'By Customer',
        value: 'customers'
      },
      {
        label: 'By Linked Account',
        value: 'linked-account'
      }
    ]
  }),
  computed: {

  },
  mounted () {
    console.log('---- VIEW -----')
    console.log(this.view)

    this.selectedVal = this.view
  },
  methods: {
    // Filter On Change
    changeRoute () {
      console.log('Selected Account', this.selectedVal)
      this.$router.push({ path: this.selectedVal })
    }

  }
}
</script>
<style>
section.monthly-cross-wrap{
    margin:5px 0
}
</style>
